// extracted by mini-css-extract-plugin
export default {"video_container":"YoutubeEmbed_video_container__Fc2Ki"};